import Vue from "vue";
import App from "./App.vue";
import toastr from "vue-toastr";
import VueI18n from 'vue-i18n'
import LangEn from './language/en_US'
import LangZhCN from './language/zh_CN'
import LangZhHK from './language/zh_HK'
import router from "./router";
import store from "./store";
import config from "./config";
import DatatableFactory from 'vuejs-datatable/dist/vuejs-datatable.esm.js';
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
import 'vue-datetime/dist/vue-datetime.css'
import './style/swiper.min.css'

import 'bootstrap-icons/font/bootstrap-icons.css';
import { Datetime } from 'vue-datetime';

import VeeValidate from 'vee-validate';

Vue.use(ElementUI);
Vue.use(VeeValidate);
Vue.use(VueI18n)
Vue.use(toastr,{
    defaultPosition: 'toast-bottom-center',
})

const i18n = new VueI18n({
    locale: 'en_US',
    messages: {
        'en_US': LangEn,
        'zh_CN': LangZhCN,
        'zh_HK': LangZhHK
    }
})
Vue.component('datetime', Datetime);

Vue.config.productionTip = false;
Vue.use(DatatableFactory);

import CKEditor from '@ckeditor/ckeditor5-vue';
Vue.use(CKEditor);

import axios from "axios"
// axios.defaults.headers.post['crossDomain'] = true;
axios.defaults.withCredentials = true;
axios.interceptors.request.use(function (config) {
  $('.spiner-postion').removeClass('hide');
  return config;
}, function (error) {
  $('.spiner-postion').addClass('hide');
  store.getters.warning.warningMsg = error.message;
  store.getters.warning.warningFalg = true;
  store.getters.warning.button = [{
              name:"Cancel",
              callBack:function(){}
            }];
  return Promise.reject(error);
})
//获取response error
axios.interceptors.response.use(function (response) {
  $('.spiner-postion').addClass('hide');
  return response;
}, function (error) {
  if (axios.isCancel(error)) {
    $('.spiner-postion').addClass('hide');
    return Promise.reject(error);
  }
  store.getters.warning.warningMsg = error.message;
  store.getters.warning.warningFalg = true;
  store.getters.warning.button = [{
              name:"Cancel",
              callBack:function(){}
            }];
  $('.spiner-postion').addClass('hide');
  return Promise.reject(error);
})
// import interceptorsSetup from './httpInterceptor'
// interceptorsSetup()
// axios.defaults.timeout = 15000;
Vue.prototype.$axios = axios
//获取request error

var mixin = {
  data() {
    return {
      langData: ["English", "Simplified Chinese", "Traditional Chinese"],
      langKey: ["en_US", "zh_HK", "zh_CN"],
      fileUploadUrl: config.fileUploadUrl,
      fileBase64UploadUrl: config.fileBase64UploadUrl,
      apiKey: config.mapApiKey
    }
  }
}


new Vue({
  mixins: [mixin],
  router,
  i18n,
  store,
  toastr,
  axios,
  render: h => h(App)
}).$mount("#app");


